import { CascadiaLayoutProps, withCascadiaLayoutProps } from "@certn/forms";
import { RenderError } from "@certn/forms/src/components/helpers/RenderError";
import { BaseLayout } from "@certn/forms/src/layouts/BaseLayout";
import { BaseLayoutContent } from "@certn/forms/src/layouts/BaseLayoutContent";
import { hasLabel } from "@certn/forms/src/utils";
import { css } from "@emotion/css";
import { isBooleanControl, rankWith } from "@jsonforms/core";
import { FitnessProprietyControlRenderer } from "../controls/fitness-propriety";
import { FitnessProprietyLayoutContext } from "./FitnessProprietyLayoutContext";
import { useApplicantAPI } from "@certn/api";
import { useApplicationFormContext } from "../ApplicationFormContext";
import { Loader } from "@certn/cascadia-react";

function FitnessProprietyLayout(props: CascadiaLayoutProps) {
  const { uischema } = props;
  const { caseId } = useApplicationFormContext();

  const { data, isLoading, error } = useApplicantAPI(
    `/api/internal/applicant/case/${caseId}/fitness-propriety-templates/`
  );

  if (!hasLabel(uischema)) {
    return <RenderError>Invalid Category</RenderError>;
  }
  if (isLoading) {
    return <Loader height="500px" />;
  }

  return (
    <BaseLayout {...props} className={styles.layout}>
      <FitnessProprietyLayoutContext.Provider
        value={{
          sectionLabel: props.label,
          subLabel: props.options?.subLabel,
          templateData: data,
          apiError: error,
        }}
      >
        <BaseLayoutContent
          renderers={[
            {
              tester: rankWith(1, isBooleanControl),
              renderer: FitnessProprietyControlRenderer,
            },
          ]}
        />
      </FitnessProprietyLayoutContext.Provider>
    </BaseLayout>
  );
}

FitnessProprietyLayout.displayName = "FitnessProprietyLayout";

const styles = {
  layout: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
};

export const FitnessProprietyLayoutRenderer = withCascadiaLayoutProps(
  FitnessProprietyLayout
);
